import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "LeftRail" */ './lazyIndex'));

export {
    HamburgerButton,
    HamburgerButtonProps,
    HamburgerHandle,
} from './components/HamburgerButton';
export { default as LeftRail } from './components/LeftRail';
export { default as ModuleSwitcher } from './components/ModuleSwitcher';

export const AppDrawer = createLazyComponent(lazyModule, m => m.AppDrawer);
